<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="column" fxLayoutAlign="space-around stretch" fxFlexFill>

                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                    <div ngModelGroup="comboColaboradorAtividade" fxFlex="100">
                        <combo-funcionario [showDisplayId]="false"
                                           [obrigatorio]="true"
                                           [selecionado]="colaboradorAtividade.funcionario"
                                           (valorChange)="onValorChangeColaborador($event)"
                                           [label]="'Selecione um funcionário'">
                        </combo-funcionario>
                    </div>
                </div>

                <div *ngIf="colaboradorAtividade.funcionario.id" style="margin-right: 50px">
                    <dados-funcionario [funcionario]=colaboradorAtividade.funcionario></dados-funcionario>
                </div>

                <div fxLayout="row" *ngIf="colaboradorAtividade.funcionario.id"
                    style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                    <div ngModelGroup="comboCargoAtividade" fxFlex="95">
                        <combo-cargo [showDisplayId]="false"
                                     [obrigatorio]="true"
                                     [selecionado]="colaboradorAtividade.cargo"
                                     (valorChange)="onValorChangeCargo($event)"
                                     [label]="'Selecione um cargo'">
                        </combo-cargo>
                    </div>
                </div>

                <div fxLayout="row" *ngIf="colaboradorAtividade.cargo.id" fxLayoutGap="50px"
                    style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                    <mat-form-field fxFlex="15%" fxFlexOffset="20px">
                        <input matInput name="dataInicio" [matDatepicker]="dataInicio" placeholder="Data de Entrada:"
                            [(ngModel)]="colaboradorAtividade.dtEntradaAtividade" required (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicio></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field fxFlex="15%">
                        <input matInput name="dataFim" [matDatepicker]="dataFim" placeholder="Data de Saída:"
                            [(ngModel)]="colaboradorAtividade.dtSaidaAtividade" (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                        <mat-datepicker #dataFim></mat-datepicker>
                    </mat-form-field>

                </div>

            </div>
        </form>
    </div>
</div>

<div dir="rtl" fxLayout="row" fxLayoutAlign="center center"
     fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
     fxFlexFill>

        <button *ngIf="!isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="zerarCombos()">
            Limpar Colaborador
        </button>

        <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary" [disabled]=formConsultar.invalid
            (click)="adicionar()">
            Adicionar Colaborador
        </button>

        <button *ngIf="isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="cancelar()">
            Cancelar Colaborador
        </button>


        <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary"
            [disabled]=formConsultar.invalid (click)="atualizar()">
            Atualizar Colaborador
        </button>

</div>
